<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17IAwSx/media/FC-9781035853830.jpg?1718732527017" alt="This image is the cover for the book Eternal Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eternal Fire
      </h1>
      <p class="bookDescription body article font2">
        <p>46-year-old Emmie’s world is upended when her lover Josh informs her that her brother Ralph has been kidnapped in Switzerland. The pair embark on a thrilling, romantic adventure across France to rescue him, encountering an array of zany characters along the way. Their journey takes them from Lyon to Geneva and even has them attempting to steal Picassos during the World Cup in Qatar – all before returning to London for a confrontation with the Sheik and an ex-cabinet minister. Swashbuckling 21st-century exploits abound in this globetrotting story, blending derring-do and amour. From Alpine intrigue to Qatari heists and beyond, Emmie’s mission to save her brother makes for a tantalizing thrill ride layered with romantic interludes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Whitlock
      </h2>
      
      <p class="authorDescription body article">After an encounter with a mystery man in 2022, the author, Katie Whitlock, was inspired to write Eternal Fire. After researching the Hadron Collider, she decided to write about her experiences. She really wants to buy a dog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03c8775a